import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
import { PapiDaSharedUserInfo } from '@wix/da-papi-types';

export const initialize = createAction(`${actionTypePrefix}/INITIALIZE`, (username: string) => ({
  username,
}));

export const requestSuccess = createAction(
  `${actionTypePrefix}/REQUEST_SUCCESS`,
  (username: string, data: PapiDaSharedUserInfo) => ({
    username,
    data,
  })
);

export const requestFailure = createAction(
  `${actionTypePrefix}/REQUEST_FAILURE`,
  (username: string) => ({ username })
);
